import { makeVar } from '@apollo/client';
import { PostHog } from 'posthog-js';

import { LOCAL_STORAGE_KEYS } from '@/constants/localStorageKeys';

import { getEnvironment, isDevelopmentMode } from './environmentUtils';

export const posthogTrackingEnabledVar = makeVar(isPosthogTrackingEnabled());

export function setDevelopmentPosthogTrackingEnabled(enabled: boolean) {
  window.localStorage.setItem(
    LOCAL_STORAGE_KEYS.ENABLE_DEVELOPMENT_POSTHOG,
    String(enabled)
  );
  posthogTrackingEnabledVar(isPosthogTrackingEnabled());
}

export function isPosthogTrackingEnabled() {
  if (!isDevelopmentMode()) return true;
  if (typeof window === 'undefined') return false;

  return (
    window.localStorage.getItem(
      LOCAL_STORAGE_KEYS.ENABLE_DEVELOPMENT_POSTHOG
    ) === 'true'
  );
}

export function getPosthogKey() {
  if (getEnvironment() === 'prod') {
    return 'phc_PTrx0j5vB6xy4Phx0QZdgdpf06lr4EL5mkiI1m9XFoq';
  }
  return 'phc_hrN1OL9g4qSO8DS1PR5JRlk2DA1U0dk3RJH6Yl7YJYq';
}

export function getPosthogSessionURL(
  posthogClient: PostHog,
  options?: { withTimestamp?: boolean }
) {
  return posthogClient.get_session_replay_url(options);
}
